import { render, staticRenderFns } from "./RemoveAppUserLog.vue?vue&type=template&id=b090b92a&lang=pug&"
import script from "./RemoveAppUserLog.vue?vue&type=script&lang=ts&"
export * from "./RemoveAppUserLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports